import { useIntl } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { useV2FTMigrationModalFooter, type V2FTMigrationModalFooterProps } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const V2FTMigrationModalFooter = ({ changeScreen, tokens }: V2FTMigrationModalFooterProps) => {
	const { $t } = useIntl();

	const { openFAQScreen, openUpgradeScreen } = useV2FTMigrationModalFooter({ changeScreen, tokens });

	return (
		<S.Wrapper aria-label="Footer">
			<Button
				fullWidth
				testID="v2FTMigrationModalFooter-upgradeNow-button"
				text={$t('v2FTMigrationInitFlow.modal.actions.upgradeNow')}
				onClick={openUpgradeScreen}
			/>

			<Button
				color="light"
				fullWidth
				testID="v2FTMigrationModalFooter-learnMore-button"
				text={$t('v2FTMigrationInitFlow.modal.actions.learnMore')}
				variant="text"
				onClick={openFAQScreen}
			/>
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xsmall};
	`;
}
